import React from 'react';
import { Card, Button } from 'react-bootstrap';
import type { BannerFormData, BannerUploadData } from './types';
import { DeviceType } from './types';
import MediaDisplay from './MediaDisplay';
import BannerForm from './BannerForm';
import type { BannerService } from './FileProcessingUtils';

interface BannerCardProps {
  index: number;
  file: BannerUploadData;
  removeUploadedFile: (index: number) => void;
  removeImage: (index: number, type: DeviceType) => void;
  updateFileField: (index: number, field: keyof BannerFormData, value: any) => void;
  // Context props to pass down to child components
  banner: BannerService;
  isUploading: boolean;
  setIsUploading: React.Dispatch<React.SetStateAction<boolean>>;
  setError: React.Dispatch<React.SetStateAction<string | null>>;
  setUploadedFiles: React.Dispatch<React.SetStateAction<BannerUploadData[]>>;
}

const BannerCard: React.FC<BannerCardProps> = ({
  index,
  file,
  removeUploadedFile,
  removeImage,
  updateFileField,
  banner,
  isUploading,
  setIsUploading,
  setError,
  setUploadedFiles,
}) => {
  return (
    <Card className="mb-4 border-2">
      <Card.Header className="d-flex justify-content-between align-items-center bg-light">
        <h5 className="mb-0">
          Banner #{index + 1} - {file.title}
        </h5>
        <Button variant="outline-danger" size="sm" onClick={() => removeUploadedFile(index)}>
          <i className="bi bi-trash"></i> Remove
        </Button>
      </Card.Header>
      <Card.Body className="bg-light bg-opacity-50 pb-4">
        <table className="w-100 mb-4">
          <tbody>
            <tr>
              <td style={{ width: '45%', padding: '0 8px', verticalAlign: 'top' }}>
                <MediaDisplay
                  index={index}
                  type={DeviceType.DESKTOP}
                  imageUrl={file.imageUrl}
                  title={file.title}
                  onRemove={removeImage}
                  banner={banner}
                  isUploading={isUploading}
                  setIsUploading={setIsUploading}
                  setError={setError}
                  setUploadedFiles={setUploadedFiles}
                />
              </td>
              <td style={{ width: '38%', padding: '0 8px', verticalAlign: 'top' }}>
                <MediaDisplay
                  index={index}
                  type={DeviceType.TABLET}
                  imageUrl={file.tabletImageUrl}
                  title={file.title}
                  onRemove={removeImage}
                  banner={banner}
                  isUploading={isUploading}
                  setIsUploading={setIsUploading}
                  setError={setError}
                  setUploadedFiles={setUploadedFiles}
                />
              </td>
              <td style={{ width: '17%', padding: '0 8px', verticalAlign: 'top' }}>
                <MediaDisplay
                  index={index}
                  type={DeviceType.MOBILE}
                  imageUrl={file.mobileImageUrl}
                  title={file.title}
                  onRemove={removeImage}
                  banner={banner}
                  isUploading={isUploading}
                  setIsUploading={setIsUploading}
                  setError={setError}
                  setUploadedFiles={setUploadedFiles}
                />
              </td>
            </tr>
          </tbody>
        </table>

        <BannerForm index={index} formData={file} updateField={updateFileField} />
      </Card.Body>
    </Card>
  );
};

export default BannerCard;
